import * as React from 'react';

import CourseraPlusRecommendationsModule from 'bundles/unified-description-page-common/components/recommendations/CourseraPlusRecommendationsModule';
import ProjectRecommendationsModuleNotConfigurable from 'bundles/unified-description-page-common/components/recommendations/ProjectRecommendationsModuleNotConfigurable';
import Section from 'bundles/unified-description-page-common/components/shared/Section';
import { usePageInfo } from 'bundles/unified-description-page-common/contexts/PageInfoContext';
import { useXdpSubscriptionsForwardDiscovery } from 'bundles/unified-description-page-common/providers/SubscriptionsForwardDiscoveryDataProvider';
import type { CollectionEntityFragment } from 'bundles/unified-description-page-common/queries/bff/__generated__/CollectionEntityFragment';
import type { ConsumerCoursePageFieldsFragment } from 'bundles/unified-description-page-common/queries/bff/__generated__/ConsumerCoursePageQuery';
import type { EnterpriseCoursePageFieldsFragment } from 'bundles/unified-description-page-common/queries/bff/__generated__/EnterpriseCoursePageQuery';

type Props = {
  pageData?: ConsumerCoursePageFieldsFragment | EnterpriseCoursePageFieldsFragment;
};

const ProjectRecommendationsModuleRenderer = ({ pageData }: Props) => {
  const { navigationIdMap } = usePageInfo();
  const { shouldShowXdpChanges } = useXdpSubscriptionsForwardDiscovery();

  return shouldShowXdpChanges ? (
    <Section anchorId={navigationIdMap?.RECOMMENDATIONS}>
      <CourseraPlusRecommendationsModule />
    </Section>
  ) : (
    <ProjectRecommendationsModuleNotConfigurable
      anchorId={navigationIdMap?.RECOMMENDATIONS}
      recommendationsCollection={pageData?.relatedRecommendations as CollectionEntityFragment[]}
    />
  );
};

export default ProjectRecommendationsModuleRenderer;
